/**
 * The door to the `terms-update` chunk: the one-time terms dialog (SOC 2 Phase 1, decision 4, 2026-10-13).
 *
 * Its host (TermsUpdateHost, on the first download beside the trial gate) asks for it only when it may show it — an
 * account with no record of the current documents, or a sign-in flow's request — so a person who has agreed never
 * downloads it. The dialog is loaded here and nowhere else (scripts/check-chat-first-paint.mjs, R4).
 */
import { createOnDemandModule } from '../../utils/onDemandModule';
// A TYPE-only import: erased at build, never an edge into the chunk.
import type * as TermsUpdateDialogNamespace from './TermsUpdateDialog';

export type TermsUpdateDialogModule = typeof TermsUpdateDialogNamespace;

const surface = createOnDemandModule<TermsUpdateDialogModule>(
  () => import(/* webpackChunkName: "terms-update" */ './TermsUpdateDialog'),
);

/** The dialog once it has arrived, or null. `mayAsk` starts the download at idle; `wanted` starts it at once. */
export const useTermsUpdateDialogModule = (mayAsk: boolean, wanted: boolean): TermsUpdateDialogModule | null =>
  surface.useModule(mayAsk || wanted, wanted);

/** Tests only: forget the download. */
export const resetTermsUpdateDialogForTests = surface.resetForTests;
